import React from 'react';

const FooterRight: React.FC = () => {

    return (
        <div className="footer2">
            <div>
                <div style={{}} className="footer-block2">
                    <a href="https://twitter.com/DegenLabs" target="_blank" rel="noreferrer">
                        <img src="/images/powered_by.png" style={{width: 100}}/>                          
                    </a>
                </div>                

            </div>
        </div>
    );
};

export default FooterRight;